import openSocket from 'socket.io-client';

const socket = openSocket('https://www.academiadasapostas.com:1555', { autoConnect: false, forceNew: true });


function subscribeLivescores(callback) {
  // console.log(socket);
  socket.on("listGames", function (today_games) {

    // console.log(today_games);
    socket.emit("subscribe", {
      type: ['soccer.match', 'soccer.events', 'soccer.matchinfo'],
      games: today_games.soccer
    });

    //This call will subscribeto any game the moment it comes live
    socket.emit("subscribe", {
      subscribelive: ['soccer.match', 'soccer.events']
    });

  });

  socket.on("connect", function () {
    // console.log("--------------- CONNECTED ----------------");
    socket.emit("listGames");
  });

  socket.on("soccer.match", function (data) {
    // console.log("################### MATCH UPDATE #####################")
    // console.log(data);
    callback(null, data);
  });

  socket.on("soccer.events", function (data) {
    // console.log("################### EVENTS UPDATE #####################")
    // console.log(data);
    callback(null, data);
  });

  socket.on("soccer.matchinfo", function (data) {
    // console.log("################### MATCHINFO UPDATE #####################")
    // console.log(data);
    callback(null, data);

  });

  // Error handling
  socket.on("error", function (data) {
    // console.log("################### ERROR #####################")
    // console.log(data);
    callback(data, null);

  });

  // Sometimes there are events that are false and need to be purged from the app
  socket.on("soccer.removeEvents", function (data) {
    // console.log("################### REMOVE EVENT #####################")
    // console.log(data);
  });

  socket.connect();

}


function subscribeLivescoreMatch(callback, matchId) {
  // console.log(socket);
  socket.on("connect", function () {
    // console.log("--------------- CONNECTED ----------------, will subscrbe:", matchId.toString());
    socket.emit("subscribe", {
      type: ['soccer.match', 'soccer.events', 'soccer.matchinfo'],
      games: [matchId.toString()]
    });
  });

  socket.on("soccer.match", function (data) {
    // console.log("################### MATCH UPDATE #####################")
    // console.log(data);
    callback(null, data);
  });

  socket.on("soccer.events", function (data) {
    // console.log("################### EVENTS UPDATE #####################")
    // console.log(data);
    callback(null, data);
  });

  socket.on("soccer.matchinfo", function (data) {
    // console.log("################### MATCHINFO UPDATE #####################")
    // console.log(data);
    callback(null, data);

  });

  // Error handling
  socket.on("error", function (data) {
    // console.log("################### ERROR #####################")
    // console.log(data);
    callback(data, null);

  });

  // Sometimes there are events that are false and need to be purged from the app
  socket.on("soccer.removeEvents", function (data) {
    // console.log("################### REMOVE EVENT #####################")
    // console.log(data);
  });

  socket.connect();

}


function closeSocket() {
  // console.log("###### closeSocket ######")
  socket.close();
}


export { subscribeLivescores, subscribeLivescoreMatch, closeSocket }
